(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('phone-call-status', {
            /*
            parent: 'entity',
            */
            parent: 'dictionary',
            url: '/phone-call-status?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneCallStatus.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-call-status/phone-call-statuses.html',
                    controller: 'PhoneCallStatusController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    /*
                    value: 'id,asc',
                    */
                    value: 'name,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneCallStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('phone-call-status-detail', {
            parent: 'phone-call-status',
            url: '/phone-call-status/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneCallStatus.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-call-status/phone-call-status-detail.html',
                    controller: 'PhoneCallStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneCallStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PhoneCallStatus', function($stateParams, PhoneCallStatus) {
                    return PhoneCallStatus.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'phone-call-status',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('phone-call-status-detail.edit', {
            parent: 'phone-call-status-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-status/phone-call-status-dialog.html',
                    controller: 'PhoneCallStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneCallStatus', function(PhoneCallStatus) {
                            return PhoneCallStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-call-status.new', {
            parent: 'phone-call-status',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-status/phone-call-status-dialog.html',
                    controller: 'PhoneCallStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                caption: null,
                                code: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('phone-call-status', null, { reload: 'phone-call-status' });
                }, function() {
                    $state.go('phone-call-status');
                });
            }]
        })
        .state('phone-call-status.edit', {
            parent: 'phone-call-status',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-status/phone-call-status-dialog.html',
                    controller: 'PhoneCallStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneCallStatus', function(PhoneCallStatus) {
                            return PhoneCallStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call-status', null, { reload: 'phone-call-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-call-status.delete', {
            parent: 'phone-call-status',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-status/phone-call-status-delete-dialog.html',
                    controller: 'PhoneCallStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PhoneCallStatus', function(PhoneCallStatus) {
                            return PhoneCallStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call-status', null, { reload: 'phone-call-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
